(() => {
  const builders = document.querySelectorAll('[data-l2c-vital-builder]');
  if (!builders.length) return;

  builders.forEach((builder) => {
    if (builder.dataset.ready === 'true') return;
    builder.dataset.ready = 'true';

    const readJson = (selector) => {
      const node = builder.querySelector(selector);
      if (!node) return [];
      try {
        return JSON.parse(node.textContent || '[]');
      } catch (error) {
        return [];
      }
    };

    const watches = readJson('[data-watch-options]').filter((item) => item.variantId);
    const copy = {
      free: 'Free',
      included: 'Included with set',
      soldOut: 'Sold out',
      notSelected: 'Not selected',
      caseSuffix: 'case',
      leatherSuffix: 'leather strap',
      viewImage: 'View image',
      completeError: 'Please complete every selection before adding to cart.',
      adding: 'Adding your complete set to cart...',
      added: 'Added. Opening your cart...',
      unable: 'Unable to add this set to cart.',
      ...readJson('[data-builder-copy]')
    };
    const siliconeOptions = readJson('[data-silicone-options]').filter((item) => item.id);
    const elasticOptions = readJson('[data-elastic-options]').filter((item) => item.id);
    const caseWrap = builder.querySelector('[data-case-options]');
    const strapWrap = builder.querySelector('[data-strap-options]');
    const siliconeWrap = builder.querySelector('[data-silicone-choices]');
    const elasticWrap = builder.querySelector('[data-elastic-choices]');
    const selectedImage = builder.querySelector('[data-selected-image]');
    const thumbWrap = builder.querySelector('[data-media-thumbs]');
    const mediaPrev = builder.querySelector('[data-media-prev]');
    const mediaNext = builder.querySelector('[data-media-next]');
    const stepStage = builder.querySelector('.l2c-vital-builder__stage');
    const stepTrack = builder.querySelector('[data-step-track]');
    const stepPanels = Array.from(builder.querySelectorAll('[data-step-panel]'));
    const progressSteps = Array.from(builder.querySelectorAll('[data-progress-step]'));
    const backButtons = Array.from(builder.querySelectorAll('[data-step-back]'));
    const nextButtons = Array.from(builder.querySelectorAll('[data-step-next]'));
    const summaryWatch = builder.querySelector('[data-summary-watch]');
    const summarySilicone = builder.querySelector('[data-summary-silicone]');
    const summaryElastic = builder.querySelector('[data-summary-elastic]');
    const summaryPrice = builder.querySelector('[data-summary-price]');
    const variantInput = builder.querySelector('[data-watch-variant-id]');
    const form = builder.querySelector('[data-builder-form]');
    const submit = builder.querySelector('[data-builder-submit]');
    const status = builder.querySelector('[data-builder-status]');

    const state = {
      step: 0,
      caseValue: '',
      strap: '',
      siliconeId: '',
      elasticId: '',
      activeMediaIndex: 0,
      mediaMode: 'watch'
    };

    const normalizeId = (value) => String(value || '').replace('gid://shopify/ProductVariant/', '');
    const unique = (items) => Array.from(new Set(items.filter(Boolean)));
    const selectedWatch = () => watches.find((item) => item.case === state.caseValue && item.strap === state.strap);
    const selectedSilicone = () => siliconeOptions.find((item) => String(item.id) === String(state.siliconeId));
    const selectedElastic = () => elasticOptions.find((item) => String(item.id) === String(state.elasticId));
    const previewWatch = () => {
      const watch = selectedWatch();
      if (watch) return watch;
      if (state.caseValue) return watches.find((item) => item.case === state.caseValue) || watches[0];
      return watches[0];
    };

    const updateStepHeight = () => {
      if (!stepStage) return;
      const activePanel = stepPanels[state.step];
      stepStage.style.setProperty('--l2c-step-height', `${activePanel?.scrollHeight || 0}px`);
    };

    const updateContinueButtons = () => {
      nextButtons.forEach((button) => {
        const nextStep = Number(button.dataset.nextStep || 0);
        let enabled = false;
        if (nextStep === 1) enabled = Boolean(state.caseValue);
        if (nextStep === 2) enabled = Boolean(selectedWatch()?.available);
        if (nextStep === 3) enabled = Boolean(selectedSilicone()?.available);
        if (nextStep === 4) enabled = Boolean(selectedElastic()?.available);
        button.disabled = !enabled;
      });
    };

    const imageSetFor = () => {
      const watch = previewWatch();
      const silicone = selectedSilicone();
      const elastic = selectedElastic();

      if (state.mediaMode === 'silicone' && silicone?.images?.length) return silicone.images;
      if (state.mediaMode === 'silicone' && silicone?.image) {
        return [{ src: silicone.image, thumb: silicone.thumb, alt: silicone.alt || silicone.title }];
      }

      if (state.mediaMode === 'elastic' && elastic?.images?.length) return elastic.images;
      if (state.mediaMode === 'elastic' && elastic?.image) {
        return [{ src: elastic.image, thumb: elastic.thumb, alt: elastic.alt || elastic.title }];
      }

      if (watch?.images?.length) return watch.images;
      if (watch?.image) return [{ src: watch.image, thumb: watch.thumb, alt: watch.alt || watch.title }];
      return [];
    };

    const updateMedia = () => {
      const images = imageSetFor();
      if (state.activeMediaIndex >= images.length) state.activeMediaIndex = 0;
      const active = images[state.activeMediaIndex] || images[0];
      if (selectedImage && active?.src) {
        selectedImage.src = active.src;
        selectedImage.alt = active.alt || '';
      }

      if (!thumbWrap) return;
      thumbWrap.innerHTML = '';
      images.forEach((image, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'l2c-vital-builder__thumb';
        button.setAttribute('aria-label', `${copy.viewImage} ${index + 1}`);
        button.setAttribute('aria-pressed', index === state.activeMediaIndex ? 'true' : 'false');
        button.innerHTML = image.thumb ? `<img src="${image.thumb}" alt="${image.alt || `${copy.viewImage} ${index + 1}`}">` : '';
        button.addEventListener('click', () => {
          state.activeMediaIndex = index;
          updateMedia();
        });
        thumbWrap.appendChild(button);
      });
      thumbWrap.hidden = images.length < 2;

      if (mediaPrev) {
        mediaPrev.disabled = images.length < 2;
        mediaPrev.hidden = images.length < 2;
      }
      if (mediaNext) {
        mediaNext.disabled = images.length < 2;
        mediaNext.hidden = images.length < 2;
      }
    };

    const showStep = (step) => {
      state.step = Math.max(0, Math.min(4, step));
      stepPanels.forEach((panel, index) => {
        const active = index === state.step;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (stepTrack) stepTrack.style.transform = `translateX(-${state.step * 100}%)`;
      requestAnimationFrame(updateStepHeight);
      if (submit) submit.hidden = state.step !== 4;
      progressSteps.forEach((node, index) => {
        node.classList.toggle('is-active', index <= Math.min(state.step, 3));
      });

      if (state.step < 2) state.mediaMode = 'watch';
      if (state.step === 2) state.mediaMode = 'silicone';
      if (state.step === 3) state.mediaMode = 'elastic';
      if (state.step === 4) state.mediaMode = 'watch';
      state.activeMediaIndex = 0;
      renderSummary();
      updateMedia();
      updateContinueButtons();
    };

    const makeButton = ({ label, sublabel, image, badge, pressed, disabled, onClick }) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = image ? 'l2c-vital-builder__choice l2c-vital-builder__choice--image' : 'l2c-vital-builder__choice';
      button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      if (disabled) button.disabled = true;
      button.innerHTML = `
        ${image ? `<span class="l2c-vital-builder__choice-image"><img src="${image}" alt="${label}"></span>` : ''}
        <span class="l2c-vital-builder__choice-copy">
          <span class="l2c-vital-builder__choice-title"><strong>${label}</strong>${badge ? `<em>${badge}</em>` : ''}</span>
          ${sublabel ? `<small>${sublabel}</small>` : ''}
        </span>
      `;
      button.addEventListener('click', onClick);
      return button;
    };

    const renderCases = () => {
      if (!caseWrap) return;
      caseWrap.innerHTML = '';
      unique(watches.map((item) => item.case)).forEach((caseValue) => {
        const sample = watches.find((item) => item.case === caseValue);
        caseWrap.appendChild(makeButton({
          label: sample?.caseDisplay || caseValue,
          image: sample?.thumb || sample?.image,
          pressed: state.caseValue === caseValue,
          onClick: () => {
            state.caseValue = caseValue;
            state.mediaMode = 'watch';
            state.activeMediaIndex = 0;
            const availableStrap = watches.find((item) => item.case === caseValue && item.strap === state.strap);
            if (!availableStrap) state.strap = '';
            state.siliconeId = '';
            state.elasticId = '';
            render();
            updateStepHeight();
          }
        }));
      });
    };

    const renderStraps = () => {
      if (!strapWrap) return;
      strapWrap.innerHTML = '';
      watches
        .filter((item) => item.case === state.caseValue)
        .forEach((item) => {
          strapWrap.appendChild(makeButton({
            label: item.strapDisplay || item.strap,
            image: item.thumb || item.image,
            badge: copy.free,
            sublabel: item.available ? copy.included : copy.soldOut,
            pressed: state.strap === item.strap,
            disabled: !item.available,
            onClick: () => {
              state.strap = item.strap;
              state.mediaMode = 'watch';
              state.activeMediaIndex = 0;
              state.siliconeId = '';
              state.elasticId = '';
              render();
              updateStepHeight();
            }
          }));
        });
    };

    const renderAccessoryChoices = (wrap, options, selectedId, setSelected, mediaMode) => {
      if (!wrap) return;
      wrap.innerHTML = '';
      options.forEach((item) => {
        wrap.appendChild(makeButton({
          label: item.title,
          image: item.thumb || item.image,
          badge: copy.free,
          sublabel: item.available ? copy.included : copy.soldOut,
          pressed: String(selectedId) === String(item.id),
          disabled: !item.available,
          onClick: () => {
            setSelected(item.id);
            state.mediaMode = mediaMode;
            state.activeMediaIndex = 0;
            render();
            updateStepHeight();
          }
        }));
      });
    };

    const renderSummary = () => {
      const watch = selectedWatch();
      const silicone = selectedSilicone();
      const elastic = selectedElastic();
      const canAdd = Boolean(watch?.available && silicone?.available && elastic?.available);

      if (summaryWatch) summaryWatch.textContent = watch ? `${watch.caseDisplay} ${copy.caseSuffix}, ${watch.strapDisplay || watch.strap} ${copy.leatherSuffix}` : copy.notSelected;
      if (summarySilicone) summarySilicone.textContent = silicone?.title || copy.notSelected;
      if (summaryElastic) summaryElastic.textContent = elastic?.title || copy.notSelected;
      if (summaryPrice) summaryPrice.textContent = watch?.price || watches[0]?.price || '';
      if (variantInput) variantInput.value = watch?.variantId || '';
      if (submit) submit.disabled = !canAdd;
      updateContinueButtons();
    };

    const render = () => {
      renderCases();
      renderStraps();
      renderAccessoryChoices(siliconeWrap, siliconeOptions, state.siliconeId, (id) => { state.siliconeId = id; }, 'silicone');
      renderAccessoryChoices(elasticWrap, elasticOptions, state.elasticId, (id) => { state.elasticId = id; }, 'elastic');
      renderSummary();
      updateMedia();
      updateContinueButtons();
    };

    const setStatus = (message) => {
      if (status) status.textContent = message;
    };

    const addToCart = async (event) => {
      event.preventDefault();
      const watch = selectedWatch();
      const silicone = selectedSilicone();
      const elastic = selectedElastic();
      if (!watch || !silicone || !elastic) {
        setStatus(copy.completeError);
        return;
      }

      submit.disabled = true;
      setStatus(copy.adding);

      const bundleId = `vital-${Date.now()}`;
      const baseProperties = {
        'Case color': watch.caseDisplay,
        'Leather strap': watch.strapDisplay || watch.strap,
        'Included silicone wristband': silicone.title,
        'Included elastic wristband': elastic.title,
        '_L2C bundle id': bundleId
      };

      const items = [
        {
          id: Number(normalizeId(watch.variantId)),
          quantity: 1,
          properties: baseProperties
        },
        {
          id: Number(normalizeId(silicone.id)),
          quantity: 1,
          properties: {
            'Included with': 'Watch2Care Vital',
            'Selected inclusion': 'Silicone wristband',
            '_L2C bundle id': bundleId,
            '_L2C parent watch SKU': watch.sku
          }
        },
        {
          id: Number(normalizeId(elastic.id)),
          quantity: 1,
          properties: {
            'Included with': 'Watch2Care Vital',
            'Selected inclusion': 'Elastic webbing wristband',
            '_L2C bundle id': bundleId,
            '_L2C parent watch SKU': watch.sku
          }
        }
      ];

      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const sections = Array.from(cartItemsComponents)
        .map((item) => item instanceof HTMLElement ? item.dataset.sectionId : '')
        .filter(Boolean);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items,
            sections,
            sections_url: window.location.pathname
          })
        });
        const payload = await response.json();
        if (!response.ok || payload.status) throw new Error(payload.description || payload.message || copy.unable);

        setStatus(copy.added);
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: payload,
            sourceId: 'l2c-vital-builder',
            data: {
              source: 'product-form-component',
              itemCount: 3,
              sections: payload.sections || {}
            }
          }
        }));

        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          window.location.href = '/cart';
        }
      } catch (error) {
        setStatus(error.message || copy.unable);
        submit.disabled = false;
      }
    };

    backButtons.forEach((button) => {
      button.addEventListener('click', () => showStep(state.step - 1));
    });

    nextButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        showStep(Number(button.dataset.nextStep || state.step + 1));
      });
    });

    mediaPrev?.addEventListener('click', () => {
      const images = imageSetFor();
      if (images.length < 2) return;
      state.activeMediaIndex = (state.activeMediaIndex - 1 + images.length) % images.length;
      updateMedia();
    });

    mediaNext?.addEventListener('click', () => {
      const images = imageSetFor();
      if (images.length < 2) return;
      state.activeMediaIndex = (state.activeMediaIndex + 1) % images.length;
      updateMedia();
    });

    window.addEventListener('resize', () => {
      updateStepHeight();
    });

    form?.addEventListener('submit', addToCart);
    render();
    showStep(0);
  });
})();
